import { TreatmentBundle } from '@customTypes/TreatmentBundle'
import { useConfig } from '@context/ConfigurationContext'
import { reportErrorToSentry } from 'src/utils/reportErrorToSentry'
import { useCityTreatments } from '@hooks/useCityTreatments'
import useClinic from '@hooks/useClinic'
import { useTreatmentPurpose } from '@hooks/useTreatmentPurpose'

export type NearbyClinicsIdWithTreatmentBundleId = Array<{ clinicId: string; treatmentBundleReferenceId: string }>

export const useNearbyClinicIdsWithTreatmentBundles = (
  nearbyClinicIds: string[]
): NearbyClinicsIdWithTreatmentBundleId => {
  const { clinicId } = useConfig()
  const { data: clinic } = useClinic(clinicId)
  const { data: cityTreatments } = useCityTreatments(clinic?.city)
  const selectedTreatmentPurposeId = useTreatmentPurpose()

  const nearbyClinicsWithTreatmentId = nearbyClinicIds
    .map((clinicId) => {
      const findTreatment = (treatment: Partial<TreatmentBundle>) =>
        treatment.clinicReferenceId === clinicId && treatment.treatmentPurposeReferenceId === selectedTreatmentPurposeId

      const category = cityTreatments?.categorizedTreatments.find((category) =>
        category.treatmentBundles.find(findTreatment)
      )

      const treatment = category?.treatmentBundles.find(findTreatment)
      if (!treatment?.referenceId) {
        reportErrorToSentry(
          `Couldnt find treatmentId when searching for treatments in city: ${clinic?.city}  for clinicId: ${clinicId} and treatmentPurposeId: ${selectedTreatmentPurposeId}`
        )
      }

      return { clinicId, treatmentBundleReferenceId: treatment?.referenceId }
    })
    .filter((el) => !!el.treatmentBundleReferenceId)

  return nearbyClinicsWithTreatmentId as NearbyClinicsIdWithTreatmentBundleId
}
